function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as c, jsx as a } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const v = (_param)=>{
    var { color: t , size: h = 24  } = _param, l = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const r = s(), e = t !== null && t !== void 0 ? t : r ? o.colors.inverse : o.colors.neutralHigh, { skinName: i  } = n();
    return i.match(/^blau/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M7.622 16.782h7.756c.388 0 .705.33.705.734 0 .404-.317.734-.705.734H7.622c-.388 0-.705-.33-.705-.734 0-.404.317-.734.705-.734zm-.705-2.937c0-.404.317-.734.705-.734h7.756c.388 0 .705.33.705.734 0 .404-.317.734-.705.734H7.622c-.388 0-.705-.33-.705-.734z"
            }),
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M4 7.429L9.479 2h9.66v20H4V7.429zM9.046 7V4.429L6.451 7h2.595zM5.442 20.571h12.255V3.43h-7.209v5H5.442v12.14z"
            })
        ]
    })) : i.match(/^o2/i) ? /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M8.072 13.072a.715.715 0 100 1.432h7.856a.715.715 0 100-1.432H8.072zm7.856 3.572H8.072a.718.718 0 00-.716.716c0 .392.32.716.716.716h7.856c.392 0 .716-.32.716-.716a.718.718 0 00-.716-.716z"
            }),
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M4.5 7.428L9.928 2H19.5v20h-15V7.428zM9.5 7V4.428L6.928 7H9.5zm8.572 13.572V3.428h-7.144v5h-5v12.144h12.144z"
            })
        ]
    })) : /* @__PURE__ */ c("svg", _object_spread_props(_object_spread({
        width: h,
        height: h,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, l), {
        children: [
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M15.545 12.827H8.444a.562.562 0 01-.56-.56c0-.308.252-.56.56-.56h7.1a.561.561 0 010 1.12zm-7.101 3.006h7.1c.309 0 .56-.252.56-.56a.562.562 0 00-.56-.56h-7.1a.562.562 0 00-.56.56c0 .308.252.56.56.56zm0 3.003h7.1c.309 0 .56-.252.56-.56a.562.562 0 00-.56-.56h-7.1a.562.562 0 00-.56.56c0 .308.252.56.56.56z"
            }),
            /* @__PURE__ */ a("path", {
                fill: e,
                d: "M5.853 21.847H18.15c.588 0 1.106-.518 1.106-1.107V7.897c0-.154-.061-.3-.174-.406L13.62 2.31a.567.567 0 00-.386-.154H5.853c-.569 0-1.107.538-1.107 1.106v17.48c0 .588.519 1.106 1.107 1.106zm12.277-1.12H5.88a.061.061 0 01-.013-.012V3.298a.085.085 0 01.022-.023h6.504v2.437c0 .956.32 1.776.916 2.376.597.6 1.42.916 2.376.916h2.45V20.72l-.005.005zM13.514 5.711V3.754l4.353 4.13h-2.182c-.65 0-1.2-.205-1.583-.589-.384-.384-.588-.93-.588-1.583z"
            })
        ]
    }));
}, H = v;
export { H as default };
